/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{4C4C81DF-3B35-45D3-95E9-AF95DA42872C}",
  "sitecoreApiHost": "",
  "jssAppName": "brimit",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/brimit",
  "graphQLEndpoint": "/api/brimit?sc_apikey={4C4C81DF-3B35-45D3-95E9-AF95DA42872C}"
};